import { BASE_URL } from "../../config";

import {
    TARIFF_CREATED,
    TARIFF_UPDATED,
    TARIFF_DELETED,
    OPEN_TARIFF_MODAL,
    CLOSE_TARIFF_MODAL,
    GET_TARIFF_LIST,
    GET_SALARY_LIST,
    UPDATE_SALARY_LIST,
    GET_NOT_PAYED_SALARY,
    PAY_SALARY,
    SHOW_PAYMENT_MODAL,
    HIDE_PAYMENT_MODAL,
} from "./salary.actionTypes";
import { loadingAction } from "../../components/loading/loading.action";
import axios from "axios";
import Notifier from "../../components/message/Notifier";

const formatMaxAndMinTime = (params) => {
    params.minDate = new Date(params.minDate).getTime();
    params.maxDate = new Date(params.maxDate).getTime();
    return params;
};


export const tariffCreated = (tariff) => {
    return {
        type: TARIFF_CREATED,
        tariff,
    };
};

export const tariffUpdated = (tariff, id) => {
    return {
        type: TARIFF_UPDATED,
        tariff,
        id,
    };
};

export const tariffDeleted = (id) => {
    return {
        type: TARIFF_DELETED,
        id,
    };
};

export const openTariffModal = (selectedTariff) => {
    return {
        type: OPEN_TARIFF_MODAL,
        selectedTariff,
    };
};

export const closeTariffModal = () => {
    return {
        type: CLOSE_TARIFF_MODAL,
    };
};

export const getTariffList = (params = {}, force = false) => {
    return (dispatch, getState) => {
        const isDefaultList = params.deleted === false && params.status === 1;

        if (isDefaultList && !force) {
            const state = getState ? getState() : {};
            const existingList = state?.tariffDetails?.tariffList;
            if (Array.isArray(existingList) && existingList.length) {
                return;
            }
        }

        const query = new URLSearchParams(params).toString();
        axios.get(`${BASE_URL}tariff/tariffList?${query}`)
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: GET_TARIFF_LIST,
                        tariffList: response.data,
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching tariff list:', error);
                // 403 errors are handled globally by axios interceptor
                // For other errors, we can show specific messages
                if (error.response && error.response.status !== 403) {
                    Notifier.error('_failed_to_load_tariff_list_', '_error_');
                }
            });
    };
};


export const createTariffByAPI = (data, cb) => {
    return (dispatch) => {
        axios.post(`${BASE_URL}tariff/`, data)
            .then((response) => {
                if (response.data) {
                    dispatch(tariffCreated(response.data));
                    Notifier.success(
                        "_tariff_successfully_created_",
                        "_tariff_created_"
                    );
                    cb(response.data);
                }
            })
            .catch((error) => {
                console.error('Error creating tariff:', error);
                if (error.response && error.response.status !== 403) {
                    Notifier.error('_failed_to_create_tariff_', '_error_');
                }
            });
    };
};

export const updateTariffByAPI = (id, data, cb) => {
    return (dispatch) => {
        axios
            .put(`${BASE_URL}tariff/updateTariff/${id}`, data)
            .then((response) => {
                if (response.data) {
                    dispatch(tariffUpdated(response.data, id));
                    Notifier.success(
                        "_tariff_successfully_updated_",
                        "_tariff_updated_"
                    );
                    cb(response.data);
                }
            })
            .catch((error) => {
                console.error('Error updating tariff:', error);
                if (error.response && error.response.status !== 403) {
                    Notifier.error('_failed_to_update_tariff_', '_error_');
                }
            });
    };
};

export const deleteTariffByAPI = (id) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}tariff/deleteTariff/${id}`)
            .then((response) => {
                if (response.data) {
                    dispatch(tariffDeleted(id));
                    Notifier.success(
                        "_tariff_successfully_deleted_",
                        "_tariff_deleted_"
                    );
                }
            })
            .catch((error) => {
                console.error('Error deleting tariff:', error);
                if (error.response && error.response.status !== 403) {
                    Notifier.error('_failed_to_delete_tariff_', '_error_');
                }
            });
    };
};
export const updateSwitchTariffByAPI = (id,status) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}tariff/status/${id}/${status}`)
            .then((response) => {
                const isActive = status === 1
                if (response.data) {
                    dispatch(getTariffList({ deleted: false, status: 1 }, true));
                    Notifier.success(
                        isActive?"_transaction_tariff_activation _":'_transaction_tariff_deactivation_'
                    );
                }
            })
            .catch((error) => {
                console.error('Error updating tariff status:', error);
                if (error.response && error.response.status !== 403) {
                    Notifier.error('_failed_to_update_tariff_status_', '_error_');
                }
            });
    };
};
export const showPaymentModal = () => {
    return {
        type: SHOW_PAYMENT_MODAL,
    };
};

export const hidePaymentModal = () => {
    return {
        type: HIDE_PAYMENT_MODAL,
    };
};

export const getSalaryList = (date) => {
    return loadingAction((dispatch, callback) => {
        const params = formatMaxAndMinTime(date);
        axios
            .get(`${BASE_URL}salary/salaryList/`, {
                params,
            })
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: GET_SALARY_LIST,
                        salaryList: response.data,
                    });
                    callback();
                }
            });
    });
};

export const updateSalaryList = (salaryList) => {
    return {
        type: UPDATE_SALARY_LIST,
        salaryList,
    };
};

export const getNotPayedSalary = (id, tariff, cb) => {
    return (dispatch) => {
        axios
            .get(`${BASE_URL}salary/notPayedSalary/${id}/${tariff}`)
            .then((response) => {
                if (response.data.length) {
                    dispatch({
                        type: GET_NOT_PAYED_SALARY,
                        distributorId: id,
                        notPayedSalaries: response.data,
                    });
                    if ("function" === typeof cb) {
                        cb();
                    }
                } else {
                    Notifier.info("_no_calculated_salary_for_distributor_");
                }
            });
    };
};

export const paySalary = (id, data, cb) => {
    return (dispatch) => {
        axios
            .put(`${BASE_URL}salary/paySalary/${id}`, data)
            .then((response) => {
                Notifier.success("salary_successfully_payed", "salary_payed");
                if (response.data) {
                    dispatch({
                        type: PAY_SALARY,
                    });
                    cb(id);
                }
            });
    };
};

export const regenerateSalaries = () => {
    return loadingAction((dispatch, callback) => {
        axios.put(`${BASE_URL}salary/regenerateSalaries`).then(() => {
            Notifier.success(
                "salary_successfully_regenerated",
                "salary_regeneration"
            );
            callback();
        });
    });
};

export const sendDeeds = (data, cb = () => {}) => {
    return (_) => {
        axios.post(`${BASE_URL}salary/send/deeds`, data).then((response) => {
            //Notifier.success('salary_successfully_payed', 'salary_payed');
            if (response.data) {
                cb();
            }
        });
    };
};
